import { render } from "./active-opportunities.page.vue?vue&type=template&id=2a2af494&ts=true"
import script from "./active-opportunities.page.vue?vue&type=script&lang=ts"
export * from "./active-opportunities.page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__